module.exports = __webpack_public_path__ + "img/PhysicsLogo.7f092667.svg";